/**
 * Authentication Service
 * Handles all authentication-related API calls
 */

import { removeAuthToken } from './apiConfig';
import { signIn as adminSignIn } from './adminApi';

/**
 * Admin Login - uses /admin/login endpoint
 * @param {Object} data - { email: string, password: string }
 * @returns {Promise}
 */
export const login = async (data) => {
  // Validate input
  if (!data || !data.email || !data.password) {
    throw new Error('Email and password are required');
  }

  // Use admin login endpoint
  const response = await adminSignIn({ email: data.email, password: data.password });
  
  return response;
};

/**
 * Logout user (clear all tokens and data from browser)
 */
export const logout = () => {
  // Remove auth token
  removeAuthToken();
  
  // Clear all localStorage data
  localStorage.clear();
  
  // Clear all sessionStorage data
  sessionStorage.clear();
};

